import React from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import { Box, IconButton, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const CacheItem: React.FC<{ cacheKey: string; onDeleteClick: () => void }> = ({ cacheKey, onDeleteClick }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title={`${t('global.delete')}`}>
        <IconButton onClick={onDeleteClick} data-testid='btn-cache-item-delete' sx={{ marginRight: 1 }}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
      {cacheKey}
    </Box>
  )
}

export default CacheItem
